module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "content-heading"
  }, [_c('i', {
    staticClass: "si si-basket mr-5"
  }), _vm._v(" Inkooporder\n    "), _c('button', {
    staticClass: "btn btn-sm btn-success btn-noborder float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createOrderListModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus mr-5"
  }), _vm._v("Nieuwe Inkooporder\n    ")])]), _vm._v(" "), _c('api-table-block', {
    ref: "orderListsTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.findAllOrders,
      "default-sort-by": "created_at",
      "item-label-singular": "bestelling",
      "item-label-plural": "bestellingen"
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(data) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.openDetailModal(data.item.id)
            }
          }
        }, [_vm._v("#" + _vm._s(data.value))])]
      }
    }, {
      key: "supplier",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(data.value) + " \n    ")]
      }
    }, {
      key: "created_at",
      fn: function(data) {
        return [_vm._v("\n      " + _vm._s(_vm._f("capitalize")(_vm._f("moment")(data.value, 'calendar'))) + "\n    ")]
      }
    }, {
      key: "status",
      fn: function(data) {
        return [_c('order-list-status-badge', {
          ref: "orderListStatusBadge",
          attrs: {
            "orderList": data.item
          }
        })]
      }
    }, {
      key: "actions",
      fn: function(data) {
        return [_c('div', {
          staticClass: "btn-group",
          attrs: {
            "role": "group"
          }
        }, [_c('button', {
          staticClass: "btn btn-sm btn-secondary  ml-3",
          on: {
            "click": function($event) {
              _vm.openDetailModal(data.item)
            }
          }
        }, [_vm._v("Details")]), _vm._v(" "), (data.item.status === 'delivered' || data.item.status === 'ordered') ? _c('button', {
          staticClass: "btn btn-sm btn-secondary  ml-3",
          on: {
            "click": function($event) {
              _vm.openCheckOrderListModal(data.item.id)
            }
          }
        }, [_vm._v("Controleren")]) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), (_vm.detailModalOrderListId) ? _c('order-list-detail-modal', {
    key: _vm.detailModalOrderListId,
    attrs: {
      "orderListId": _vm.detailModalOrderListId
    },
    on: {
      "close": function($event) {
        _vm.detailModalOrderListId = null, _vm.refresh()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.checkOrderListModalId) ? _c('check-order-list-modal', {
    attrs: {
      "orderListId": _vm.checkOrderListModalId
    },
    on: {
      "close": function($event) {
        _vm.checkOrderListModalId = null, _vm.refresh()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orderedOrderModalListId) ? _c('ordered-order-list-modal', {
    key: _vm.orderedOrderModalListId,
    attrs: {
      "orderListId": _vm.orderedOrderModalListId,
      "status": _vm.currentStatus
    },
    on: {
      "close": function($event) {
        _vm.orderedOrderModalListId = null, _vm.currentStatus = null, _vm.refresh()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showCreateOrderListModal) ? _c('create-order-list-modal', {
    attrs: {
      "productIds": [],
      "fromScratch": true
    },
    on: {
      "close": function($event) {
        _vm.showCreateOrderListModal = null, _vm.refresh()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('select-barcode-scanner-widget')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33117330","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/order-lists/OrderListPage.vue
// module id = 703
// module chunks = 1